module.exports = __webpack_public_path__ + "static/media/Petal.5fbac50e.svg";